import { createCpmsBoCustomerSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-customer.slice';

import { cpmsBoCustomerApi } from './cpms-bo-customer.service';

export const cpmsBoCustomerSlice = createCpmsBoCustomerSlice({
  cpmsBoCustomerApi,
});
